import { IError } from '../base/error'
import ServiceBase from '../base/service.base'

import {
  ICompanyProductionStep,
  ICreateUpdateCompanyProductionStep,
} from './company-production-steps.types'

export class CompanyProductionSteps extends ServiceBase {
  public async getCompanyProductionStepAssets(
    companyProductionStepId: string,
  ): Promise<ICompanyProductionStep> {
    const url = `/company-production-steps/${companyProductionStepId}`

    const response = await this.request.get<ICompanyProductionStep, IError>(url)

    if (response.result) {
      return response.result
    } else {
      const error = response.error as IError
      throw new IError(error.statusCode, error.message, error.error)
    }
  }

  public async uploadCompanyProductionStepAssets(
    companyProductionStepId: string,
    assets: FormData,
  ): Promise<ICompanyProductionStep> {
    const url = `/company-production-steps/${companyProductionStepId}/assets`

    const response = await this.request.post<ICompanyProductionStep, IError>(
      url,
      assets,
    )

    if (response.result) {
      return response.result
    } else {
      const error = response.error as IError
      throw new IError(error.statusCode, error.message, error.error)
    }
  }

  public async deleteCompanyProductionStepImage(
    companyProductionStepId: string,
    imageUrl: string,
  ): Promise<ICompanyProductionStep> {
    const url = `/company-production-steps/${companyProductionStepId}/images`

    const response = await this.request.delete<ICompanyProductionStep, IError>(
      url,
      {
        params: {
          imageUrl,
        },
      },
    )

    if (response.result) {
      return response.result
    } else {
      const error = response.error as IError
      throw new IError(error.statusCode, error.message, error.error)
    }
  }

  public async udateCompanyProductionStep(
    companyProductionStepId: string,
    data: ICreateUpdateCompanyProductionStep,
  ): Promise<ICompanyProductionStep> {
    const url = `/company-production-steps/${companyProductionStepId}`

    const response = await this.request.put<ICompanyProductionStep, IError>(
      url,
      data,
    )

    if (response.result) {
      return response.result
    } else {
      const error = response.error as IError
      throw new IError(error.statusCode, error.message, error.error)
    }
  }
}
